"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Controls = require("./Controls");
Object.keys(_Controls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Controls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Controls[key];
    }
  });
});